import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_STAFF_TIME_SHEET } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const staffTimeSheet = {
  namespaced: true,
  state: buildInitialState({
    staffTimeSheetEntries: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setTimeSheetEntries: (state, staffTimeSheetEntries) => {
      state.staffTimeSheetEntries = staffTimeSheetEntries
    }
  },
  actions: {
    getStaffTimeSheetEntries: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting time, please wait...' })

      return api.doGet({ path: PATH_STAFF_TIME_SHEET, parameters: filters })
        .then(json => json.data)
        .then(staffTimeSheetEntries => {
          commit('updateStatus', { status: COMPLETE })
          commit('setTimeSheetEntries', staffTimeSheetEntries)
          return staffTimeSheetEntries
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get time. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveStaffTimeSheetEntries: ({ commit, dispatch }, payLoad) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving time, please wait...' })
      return api.doPost({ path: PATH_STAFF_TIME_SHEET, data: payLoad })
        .then(json => json.data)
        .then(staffTimeSheetEntries => {
          commit('updateStatus', { status: COMPLETE })
          if (!staffTimeSheetEntries) {
            throw new Error('Unable to save time. Try again later')
          }
          notifySuccess(dispatch, 'Time saved')
          return staffTimeSheetEntries
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save time. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default staffTimeSheet
